<template>
 <v-menu v-model="menu" offset-y style="z-index: 9999999999999999999999;">
  <template #activator="{ props }">
    <span
      v-bind="props"
      style="font-size: 18px; padding-right: 12px; cursor: pointer;"
       :style="{...sysTypo.sectionTypography.button,  color: themeStore.sectionTheme.systemBarColor }"
    >
      🌐{{ langStore.currentLanguage.toUpperCase() }}
    </span>
  </template>

  <v-card
    flat
    :style="{...sysTypo.sectionTypography.button, background: themeStore.sectionTheme.systemBarBg, color: themeStore.sectionTheme.systemBarColor }"
    style="z-index: 9999999999999999999999;"
  >
    <v-list>
      <v-list-item
        v-for="lang in mappedLanguages"
        :key="lang.value"
        :active="lang.value === langStore.currentLanguage"
        @click="changeLanguage(lang)"
      >
        <v-list-item-title>
          {{ lang.text }} ({{ lang.value }})
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</v-menu>

</template>

<script setup>
import { computed, onMounted, ref } from "vue"
import { useRouter, useRoute } from "vue-router"
import { useI18n } from 'vue-i18n'
import { useToast } from 'vue-toastification'
const { t, locale } = useI18n()
import { useLangStore } from '@/store/lang'
import { useAuthStore } from "@/store/auth"

import { useThemeStore } from "@/store/auth"
import { useSysTypo } from "@/store/useSysTypo";

const themeStore = useThemeStore()
const sysTypo = useSysTypo();

const auth = useAuthStore() 

const langStore = useLangStore()
const lang = computed(() => langStore.currentLanguage || "en")
const toast = useToast()

const router = useRouter()
const route = useRoute()
const menu = ref(false)
const langCode = ref('')
langCode.value = langStore.currentLanguage

// Map langStore → your component format (no flags)
const mappedLanguages = computed(() =>
  langStore.languages.map(l => ({
    text: l.label,
    value: l.code
  }))

)

function changeLanguage(lang) {
  langStore.setLanguage(lang.value)
    langCode.value = localStorage.getItem('locale')
    localStorage.setItem('locale', langCode.value)
  router.push({
    name: route.name,
    params: {
      ...route.params,
      lang: lang.value
    },
    query: route.query
  })

  menu.value = false
}

onMounted(() => {

})
</script>